<div class="bems-footer footer-tab footer-dark">
    <div class="hidden-sm hidden-xs" id="footer-b-outter">
        Copyright 2021 , Chulalongkorn University Smart Environment System
        <!-- Copyright 2019 , Chulalongkorn University Building Energy Management System -->
    </div>
    <div class="bems-footer-container">
        <span class="bems-footer-text"><span>{{ dataHeadTiltle }}</span><br><span>{{ dataSubTitle }}</span></span>
        <img class="footerImg hidden-sm hidden-xs" src="assets/images/cover.png" style="width: 45%;margin-bottom: -20px;">
    </div>
</div>